module.exports = __webpack_public_path__ + "static/media/mf.31af3e47.mp4";